export default __webpack_public_path__ + "static/media/Tauana.2fd0ef32.svg";